module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('a', {
    attrs: {
      "id": "pageiii"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("EXPANDING OUR NOW")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("The Story of Open Space Technology")]), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("HARRISON OWEN")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/0001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Berrett-Koehler Publishers, Inc. San Francisco")])])])]), _c('a', {
    attrs: {
      "id": "pageiii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12cfb4d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title.vue
// module id = 63
// module chunks = 0